@switch (state) {
  @case ('accepted') {
    <span>{{ 'VALUE.INVITATION_ACCEPTED' | translate }}</span>
  }
  @case ('none') {
    @if (canSend) {
      <restricted-text-button (onClick)="onClickSend($event)">
        {{ 'VALUE.SEND_INVITATION' | translate }}
      </restricted-text-button>
    } @else {
      <span>{{ 'VALUE.INVITATION_NONE' | translate }}</span>
    }
  }
  @case ('sending') {
    <span>{{ 'VALUE.INVITATION_SENDING' | translate }}</span>
  }
  @case ('sent') {
    <div>
      <span>{{ 'VALUE.INVITATION_SENT' | translate }}</span>
      @if (canSend) {
        <restricted-icon-button
          (onClick)="onClickResend($event)"
          icon="mdi-refresh"
          iconClass="sm"
          [matTooltip]="'TOOLTIP.RESEND_INVITATION' | translate"
          [permissions]="[Permission.MANAGE_USER]">
        </restricted-icon-button>
      }
    </div>
  }
}
